import { useCurrency } from './shared'
import { t } from '../../../i18n'

const CHALK = "'Segoe Print', 'Bradley Hand', 'Comic Sans MS', cursive"

// A cafe chalkboard behind a wooden frame: handwritten chalk type, sections
// flowing in masonry columns, little round photos - tap a line to add it.
export default function CafeTemplate({ menu, table, addItem, onSelectItem }) {
  const currency = useCurrency()
  const categories = menu.filter(c => c.items?.length)

  return (
    <div className="max-w-5xl mx-auto">
      <div className="rounded-[28px] p-3 md:p-5 shadow-2xl" style={{ background: 'linear-gradient(135deg,#8b5a2b,#5c3a1a 45%,#7a4b22)' }}>
        <div className="rounded-2xl px-6 md:px-12 py-10 md:py-14 text-[#f4f1ea] relative overflow-hidden"
          style={{ background: 'radial-gradient(circle at 30% 20%,#3d5a45,#24362b 70%)', fontFamily: CHALK }}>
          <span className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{ backgroundImage: 'repeating-linear-gradient(115deg,#fff 0 1px,transparent 1px 7px)' }} aria-hidden="true" />
          <header className="relative text-center mb-10">
            <p className="text-lg text-[#f9d98c]">{t("~ fresh today ~")}</p>
            <h1 className="text-5xl md:text-6xl mt-2 -rotate-1">{t("Today's Menu")}</h1>
            {table && <p className="mt-3 text-[#cfe3d3]">{t("Table")} {table}</p>}
          </header>

          <div className="relative columns-1 md:columns-2 gap-12">
            {categories.map((c, ci) => (
              <section key={c.id} className="break-inside-avoid mb-10">
                <h2 className="text-3xl mb-5 inline-block" style={{ color: ['#f9d98c', '#f6b3b3', '#b8e0c5', '#b9d4f5'][ci % 4], textDecoration: 'underline wavy', textUnderlineOffset: 8 }}>{c.name}</h2>
                <ul className="space-y-4">
                  {c.items.map(item => (
                    <li key={item.id} className="flex items-center gap-3">
                      {item.image && <img loading="lazy" src={item.image} alt="" className="w-12 h-12 rounded-full object-cover border-2 border-[#f4f1ea]/60 shrink-0" onError={e => { e.currentTarget.style.display = 'none' }} />}
                      <button onClick={() => onSelectItem(item)} className="flex-1 min-w-0 text-start">
                        <span className="flex items-baseline gap-2">
                          <span className="text-lg">{item.name}</span>
                          <span className="flex-1 border-b-2 border-dotted border-[#f4f1ea]/40" aria-hidden="true" />
                          <span className="text-lg text-[#f9d98c] whitespace-nowrap">{Number(item.price || 0).toFixed(2)}</span>
                        </span>
                        {item.description && <span className="block text-sm text-[#cfd8cc] leading-snug">{t(item.description)}</span>}
                      </button>
                      <button onClick={() => addItem(item)} aria-label={t("Add {name}", { name: item.name })} className="w-9 h-9 shrink-0 rounded-full border-2 border-[#f4f1ea]/70 text-xl leading-none hover:bg-[#f4f1ea] hover:text-[#24362b] transition-colors">+</button>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
          <p className="relative text-center text-[#cfe3d3] mt-4">{t("prices in")} {currency} {t("· ask us about today's cakes ♡")}</p>
        </div>
      </div>
    </div>
  )
}
